import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import RichTextEditorFieldWithFileUpload from 'components/RichTextEditorFieldWithFileUpload';
import { AxiosRequestConfig } from 'axios';
import dataRoomApi from '../../dataRoomApi';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import { QuestionFile } from '../../models/QAndA';

import './QuestionRichTextEditor.styles.scss';

type QuestionRichTextEditorProps = {
  className?: string;
  label: string;
  questionId?: string;
  initialFiles?: QuestionFile[];
  onRemoveQuestionFile?: (fileId: string) => void;
};

const QuestionRichTextEditor: React.FC<QuestionRichTextEditorProps> = (
  props,
) => {
  const {
    className,
    label,
    questionId,
    initialFiles = [],
    onRemoveQuestionFile,
  } = props;

  const classes = classNames('question-rich-text-editor', className);

  const {
    dataRoom: { _id: dataRoomId },
  } = useContext(DataRoomContext);

  const uploadRequest = useCallback(
    (file: File, config: AxiosRequestConfig) =>
      dataRoomApi.questionsAndAnswers.uploadQuestionFile(
        file,
        dataRoomId,
        config,
      ),
    [dataRoomId],
  );

  const deleteRequest = useCallback(
    async (fileId: string) => {
      if (questionId) {
        await dataRoomApi.questionsAndAnswers.removeQuestionFile(
          questionId,
          fileId,
        );

        onRemoveQuestionFile?.(fileId);
      }
    },
    [questionId, onRemoveQuestionFile],
  );

  return (
    <RichTextEditorFieldWithFileUpload
      className={classes}
      label={label}
      richTextEditorName="content"
      filesName="uploadedFiles"
      initialFiles={initialFiles.map(({ _id, file }) => ({ ...file, _id }))}
      onUploadRequest={uploadRequest}
      onDeleteRequest={deleteRequest}
    />
  );
};

export default QuestionRichTextEditor;
